<div fxLayout="column" class="page-container">
  <div fxLayout="column" class="eon-backdrop" fxLayoutAlign="center center">
    <div fxLayoutAlign="center center" class="eon-logo" fxFlex="10">
      <mat-icon svgIcon="logo-red"></mat-icon>
    </div>
    <div fxFlex="90" class="content-container" fxLayoutAlign="center center" fxLayout="column">
      <h1 class="splash-headline" fxLayoutAlign="center center">Tech Core Quiz</h1>
      <div ngClass.lt-sm="hologram-container-xs" ngClass.gt-xs="hologram-container-sm">
        <img ngSrc="assets/branding/hologramm%20small.png" alt="Hologram" height="500" width="500"  priority>
      </div>
      <div class="button-container" fxLayoutAlign="center center">
        <eon-ui-button text="SSO Login" (click)="start()" scheme="white" fullWidth="true" class="primary-button"></eon-ui-button>
      </div>
    </div>
  </div>
</div>
